import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-ef1e1a22"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "teacher-photo"
};
const _hoisted_2 = {
  class: "teacher-photo-inner"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "base-info"
};
const _hoisted_5 = {
  class: "name text-overflow"
};
const _hoisted_6 = ["title"];
const _hoisted_7 = ["title", "innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "teacher-card",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.openDetail && $options.openDetail(...args))
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: $props.teacherData.avatar_url || require('@/assets/images/common/teacher_icon.png'),
    alt: ""
  }, null, 8, _hoisted_3)])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString($props.teacherData.teacher_name), 1), _createElementVNode("span", {
    class: "teacher-info text-overflow",
    title: $props.teacherData.organ_name && $props.teacherData.title_name ? $props.teacherData.organ_name + ' ' + $props.teacherData.title_name : $props.teacherData.organ_name || $props.teacherData.title_name
  }, [_createElementVNode("span", null, _toDisplayString($props.teacherData.organ_name), 1)], 8, _hoisted_6)]), _createElementVNode("div", {
    class: "intro",
    title: _ctx.$utils.getContentText($props.teacherData.introduction),
    "data-html": "",
    innerHTML: _ctx.$utils.getContentText($props.teacherData.introduction)
  }, null, 8, _hoisted_7)]);
}